import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        color: "#fff",
        maxWidth: 1200,
        margin: "auto",
        marginTop: 110,
        paddingBottom: 0,
        [theme.breakpoints.down('lg')]: {
            // maxWidth: 1050,
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            marginTop: 70,
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: 80,
            padding: "16px 0px 0px"
        },
    },
    header: {
        marginBottom: theme.spacing(6),
        textAlign: "center",
    },
    titleBox: {
        width: 955,
        margin: 'auto',
        marginBottom: 100,
        [theme.breakpoints.down('md')]: {
            width: '80%',
            marginLeft: '10%',
            marginBottom: 100,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginLeft: '0%',
            marginTop: -100,
            marginBottom: 75,
        },
    },
    title: {
        marginTop: 100,
        marginBottom: 20,
        textAlign: 'center',
        fontSize: '1.8em',
        color: '#fff',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5em'
        },
        [theme.breakpoints.down('xs')]: {
            textAlign: 'left',
            marginLeft: 20,
            marginTop: 150,
            fontSize: '1.4em'
        },
    },
    // sectionContainer: {
    //     marginBottom: 1,
    //     [theme.breakpoints.down('sm')]: {
    //         padding: 24,
    //         marginBottom: "500px !important",
    //     },
    // },
    gridItem: {
        paddingBottom: 70,
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 32
        },
    },
    phoneLink: {
        color: '#fff',
        textDecoration: 'none',
        fontWeight: 500,
        fontFamily: 'serif',
    },
    subText: {
        fontSize: '1.2em',
        fontWeight: 500,
        marginTop: 40,
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2em',
        },
    },
    mainGridContainer: {
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        width: '100%',
        margin: 'auto',
        [theme.breakpoints.down('md')]: {
            maxWidth: 850,
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: 0,
            marginBottom: 0,
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: 0,
        },
    },
    topGridItem: {
        backgroundColor: 'white',
        padding: '20px 30px',
        borderBottom: '2px solid #efefef',
        color: '#ecececff',
        height: 80,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        fontSize: '.8rem',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    viewOptions: {
        cursor: 'pointer',
        color: '#858a94',
        [theme.breakpoints.down('xs')]: {
            fontSize: 'smaller'
        },
    },
    imageGridContainer: {
        minWidth: '300px',
        borderRight: '2px solid #efefef',
        padding: 50,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            padding: '25px 25px 10px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '50px 50px 10px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '25px 25px 0px',
            borderRight: 'none !important',
        },
    },
    imageStyles: {
        width: '100%',
        height: 'auto',
        borderRadius: '8px !important',
        display: 'block',
        aspectRatio: '4 / 3', // 600 / 450
        objectFit: 'contain',
        [theme.breakpoints.down('xs')]: {
            borderRadius: '3px !important',
        },
    },
    descriptionContainer: {
        fontFamily: 'Raleway, sans-serif',
        padding: '15px 39px',
        fontSize: '.8rem',
        color: "black",
        [theme.breakpoints.down('sm')]: {
            paddingTop: '10px',
            paddingLeft: '50px',
        },
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 25,
            paddingRight: 25,
        },
    },
    sectionTitle: {
        color: '#333333',
        fontFamily: 'Raleway, sans-serif',
        fontWeight: '600',
        paddingTop: '15px',
        margin: '0',
        fontSize: '2rem',
        lineHeight: '1',
        marginBottom: 7,
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
            textAlign: 'center',
            textWrap: 'balance',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.8rem',
            marginBottom: 5,
        },
    },
    subTitle: {
        margin: '6px 0 0px 0',
        fontFamily: 'Raleway, sans-serif',
        fontSize: '1rem',
        color: '#ba4419',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            // textWrap: 'balance',
        },
    },
    description: {
        fontFamily: 'Raleway, sans-serif',
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
        paddingBottom: 0,
        fontSize: '1rem',
    },
    bulletList: {
        paddingLeft: 5,
        fontSize: '1em',
        [theme.breakpoints.down('xs')]: {
            marginTop: 5,
        },
    },
    listItem: {
        padding: 0,
        paddingBottom: 5,
        alignItems: 'center',
        fontSize: '1.1em',
        '& .MuiListItemText-primary': {
            lineHeight: '1.2em',
            fontSize: '1em',
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: -20,
        },
    },
    icon: {
        color: "#66bb6a",
        fontSize: '1.2rem',
        minWidth: 24,
        marginLeft: 20,
    },

    /* bottom button bar */
    buttonView: {
        height: 85,
        backgroundColor: '#edf0f8',
        borderTop: '2px solid #efefef',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
    },
    buttonGroup: {
        display: 'flex',
        marginLeft: '4%',
        marginRight: '4%',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '12px !important',
            marginRight: "10px !important",
        },
    },
    contactButton: {
        color: '#fff !important',
        fontWeight: 500,
        textTransform: "none",
        minWidth: 130,
        width: '49%',
        height: 40,
        borderRadius: 5,
        marginRight: 5,
        '&:first-of-type': {
            background: '#3e495f',
            '&:hover, &:focus': {
                backgroundColor: '#2c313c',
            },
        },
        '&:last-of-type': {
            backgroundColor: '#114796',
            '&:hover, &:focus': {
                backgroundColor: '#0b3879',
            },
        },
        [theme.breakpoints.down('sm')]: {
            height: 40,
        }
    },
}));

export default useStyles;